<template>
    <footer class="footer">
        <Container width="landing">
            <div class="footer__wrapper">
                <div class="footer__top">
                    <div class="footer__info">
                        <div class="footer__logo">
                            <img src="/images/logo.svg" alt="" />
                        </div>

                        <div class="footer__info-description">
                            Управляйте продажами, следите за конкурентами и увеличивайте прибыль.
                        </div>
                        <UiButton to="/login" class="footer__login">
                            Войти
                        </UiButton>
                    </div>
                    <nav class="footer__nav">
                        <div v-for="item in navigation" :key="item.id" class="footer__nav-column">
                            <NuxtLink to="/blog" class="footer__nav-title">
                                {{ item.title }}
                            </NuxtLink>
                            <ul class="footer__nav-list">
                                <li v-for="link in item.list" :key="link.label">
                                    <NuxtLink :to="link.href" class="footer__nav-link">
                                        {{ link.label }}
                                    </NuxtLink>
                                </li>
                            </ul>
                        </div>
                    </nav>
                    <div class="footer__contacts">
                        <div class="footer__contacts-title">
                            Контакты
                        </div>
                        <div class="footer__contacts-address">
                            123456, г. Москва, ул. Солнечная, д. 15, офис 4
                        </div>

                        <a href="tel:+8 765 543 32 54" class="footer__contacts-phone">
                            +8 765 543 32 54
                        </a>

                        <a href="mailto:info@mbrain.ru" class="footer__contacts-email">
                            info@mbrain.ru
                        </a>

                        <div class="footer__contacts-socials">
                            <a v-for="(social, index) in socials"
                               :key="index"
                               class="footer__contacts-social"
                               :href="social.link"
                            >
                                <WBIcon :name="social.icon" />
                            </a>
                        </div>
                    </div>
                </div>
                <div class="footer__bottom">
                    <div class="footer__copyright">
                        MarketBrain© 2024
                    </div>
                    <div class="footer__terms">
                        <NuxtLink to="/blog">
                            Пользовательское соглашение
                        </NuxtLink>
                        <NuxtLink to="/blog">
                            Политика конфиденциальности
                        </NuxtLink>
                        <NuxtLink to="/blog">
                            Политика оплаты и возврата
                        </NuxtLink>
                    </div>

                    <CreatedBy class="footer__created-by" />
                </div>
            </div>
        </Container>
    </footer>
</template>

<script setup>
    import Container from '~/src/shared/components/common/Container/Container.vue'
    import CreatedBy from '~/src/shared/components/common/created-by/CreatedBy.vue'

    const navigation = [
        {
            id: 1,
            title: 'Сервис',
            list: [
                {
                    label: 'О компании',
                    href: '/',
                },
                {
                    label: 'Тарифы',
                    href: '/',
                },
                {
                    label: 'Блог',
                    href: '/',
                },
            ],
        },
        {
            id: 2,
            title: 'Подключения',
            list: [
                {
                    label: 'Мои подключения',
                    href: '/',
                },
            ],
        },
        {
            id: 3,
            title: 'Инструменты',
            list: [
                {
                    label: 'Мониторинг позиций',
                    href: '/',
                },
                {
                    label: 'Поиск трафика',
                    href: '/',
                },
                {
                    label: 'Анализ блогеров',
                    href: '/',
                },
                {
                    label: 'Редирект',
                    href: '/',
                },
            ],
        },

        {
            id: 3,
            title: 'ИИ-помошник',
            list: [
                {
                    label: 'Описание карточек',
                    href: '/',
                },
            ],
        },
    ]
    const socials = [
        { icon: 'youtube', link: '/' },
        { icon: 'telegram', link: '/' },
        { icon: 'instagram', link: '/' },
    ]
</script>

<style lang="scss" scoped>
.footer {
        &__wrapper {
            margin: 0 calc(var(--container-offset) * -1);
            padding: 0 var(--container-offset);
            border-radius: 40px 40px 0 0;
            background-color: var(--white);
        }

        &__top {
            display: flex;
            justify-content: space-between;
            padding: 40px 0 32px;

            @include respond-to(tablet) {
                flex-flow: wrap;
            }

            @include respond-to(mobile) {
                align-items: center;
                flex-flow: column;
            }
        }

        &__info {
            display: flex;
            align-items: flex-start;
            flex-flow: column;
            width: 100%;
            max-width: 250px;

            @include respond-to(mobile) {
                align-items: center;
                max-width: 336px;
            }
        }

        &__info-description {
            margin-top: 16px;

            @include respond-to(mobile) {
                text-align: center;
            }
        }

        &__logo {
            height: 30px;
        }

        &__login {
            margin-top: 16px;
        }

        &__nav {
            display: flex;
            justify-content: space-between;
            width: 100%;
            max-width: 740px;

            @include respond-to(tablet) {
                order: 3;
                max-width: 100%;
                margin-top: 32px;
            }

            @include respond-to(mobile) {
                justify-content: center;
                flex-flow: wrap;
                order: 2;
                margin-top: 32px;
            }
        }

        &__nav-column {
            @include respond-to(mobile) {
                display: flex;
                width: calc(50% - 12px);
                margin: 0 6px;
            }

            &:nth-child(odd) {
                @include respond-to(mobile) {
                    justify-content: flex-end;
                }
            }
        }

        &__nav-title {
            @include mulish19s;
        }

        &__nav-list {
            margin-top: 8px;

            @include respond-to(mobile) {
                display: none;
            }

            li {
                &:not(:first-child) {
                    margin-top: 8px;
                }
            }
        }

        &__nav-link {
            @include mulish16r
        }

        &__contacts {
            display: flex;
            align-items: flex-end;
            flex-flow: column;
            width: 100%;
            max-width: 190px;
            text-align: right;

            @include respond-to(mobile) {
                align-items: center;
                order: 3;
                max-width: 336px;
                margin-top: 32px;
            }
        }

        &__contacts-title {
            @include mulish19s;

            @include respond-to(mobile) {
                display: none;
            }
        }

        &__contacts-address {
            @include manrope14r;

            margin-top: 16px;
        }

        &__contacts-phone {
            margin-top: 12px;

            @include mulish20b;
        }

        &__contacts-email {
            @include manrope16r;

            margin-top: 12px;
        }

        &__contacts-socials {
            display: flex;
            justify-content: flex-end;
            margin-top: 12px;
        }

        &__contacts-social {
            display: flex;
            align-items: center;
            justify-content: center;
            width: 28px;
            height: 28px;
            margin-left: 16px;
            border-radius: 50%;
            background-color: var(--indigo-300);
            font-size: 14px;
            color: var(--white);
        }

        &__bottom {
            display: flex;
            align-items: center;
            justify-content: space-between;
            flex-flow: wrap;
            padding: 16px 0 24px;
            border-top: 1px solid var(--grey-200);
            background-color: var(--white);
            color: var(--grey-400);
        }

        &__copyright {
            @include manrope14r;
        }

        &__terms {
            @include manrope14r;

            @include respond-to(tablet) {
                display: flex;
                justify-content: space-between;
                order: -1;
                width: 100%;
                margin-bottom: 24px;
            }

            @include respond-to(mobile) {
                align-items: center;
                flex-flow: column;
            }

            a {
                &:not(:last-child) {
                    margin-right: 20px;

                    @include respond-to(mobile) {
                        margin-right: 0;
                        margin-bottom: 8px;
                    }
                }

                @include respond-to(mobile) {
                    text-align: center;
                }
            }
        }
    }
</style>
